<template>
  <div class='paginated-table'>
    <Table :columns="tableColumns"
           :data="data"
           :loading="loading"
           :width="width"
           @on-sort-change="handleSortChange"
           stripe highlight-row border>
      <template slot-scope="{ row, column, index }" slot="propertyCell">
        <Tooltip class="ivu-table-cell-tooltip" v-if="column.tooltip" :content="_.get(row, column.key)">
          <span class="ivu-table-cell-tooltip-content">{{ _.get(row, column.key) }}</span>
        </Tooltip>
        <span v-else>{{ _.get(row, column.key ) }}</span>
      </template>
      <template slot-scope="{ row, column, index }" slot="imageCell">
        <img src="" alt="">
      </template>
      <template v-for="(slot, slotIndx) in slots" slot-scope="{ row, column, index }" :slot="slot.name">
        <paginated-table-slot :callback-render="slot.render"
                              :args="{ row, column, index }"
                              :key="slotIndx">
        </paginated-table-slot>
      </template>
    </Table>
    <Page v-if="showPage"
          :total="Number(paginate.total)"
          :page-size="Number(paginate.per_page)"
          :current="Number(paginate.current_page)"
          @on-change="handlePaginationChange"
          show-total></Page>
  </div>
</template>

<script>
import { get } from '@/libs/api.request'
import { searchQueryBuilder } from '@/api/search'
import PaginatedTableSlot from './slot'
export default {
  name: 'PaginatedTable',
  components: {
    PaginatedTableSlot
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    slots: {
      type: Array,
      required: false,
      default: () => []
    },
    initOptions: {
      type: Object,
      required: false
    },
    url: {
      type: String,
      requried: false
    },
    showActionColumn: {
      type: Boolean,
      required: false,
      default: false
    },
    width: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      paginate: {
        current_page: 0,
        total: 0,
        per_page: 0
      },
      options: {},
      data: [],
      loading: false,
      tableColumns: []
    }
  },
  computed: {
    showPage: function () {
      return this.paginate.total > this.data.length
    }
  },
  mounted () {
    this.tableColumns = this.columns
    if (this.showActionColumn) {
      this.addActionColumn()
    }
    this.options = Object.assign({}, this.options, this.initOptions)
    this.loadData(this.buildUrl(this.options))
  },
  methods: {
    loadData (url) {
      this.loading = true
      get(url).then(resp => {
        this.loading = false
        this.data = resp.data.data
        this.paginate = resp.data.meta
        this.$emit('loaded', this.data)
      }).finally(() => {
        this.loading = false
      })
    },
    refresh (options, reset_page = false) {
      if (reset_page) {
        options['paginate'] = { page: 1 }
      }
      this.options = Object.assign({}, this.options, options)
      // const params = Object.assign({}, { page: this.paginate.current_page }, options)
      this.loadData(this.buildUrl(this.options))
    },
    handlePaginationChange (page) {
      this.options = Object.assign({}, this.options, { paginate: { page: page } })
      this.loadData(this.buildUrl(this.options))
    },
    handleSortChange (col) {
      this.options = Object.assign({}, this.options, { sort: { [col.key]: col.order } })
      this.loadData(this.buildUrl(this.options))
    },
    buildUrl (params) {
      let queryString = searchQueryBuilder.buildQueryString(params, 'get')

      var target = this.url
      if (queryString !== '') {
        target = this.url + '?' + queryString
      }
      return target
    },
    addActionColumn () {
      // iview problem, we have to emliniate the dynamically added column,
      // otherwise, when returning to the table, the action button on-click event
      // won't get emitted.
      this.tableColumns = this.tableColumns.filter(function(col) {
        return col.key !== 'action'
      })

      this.tableColumns.push({
        title: 'Actions',
        key: 'action',
        minWidth: 70,
        maxWidth: 120,
        align: 'center',
        render: (h, params) => {
          return h('Button', {
            props: {
              type: 'text'
            },
            on: {
              click: () => {
                this.$emit('on-row-edit', params.row, params.index)
              }
            }
          }, [h('Icon', { props: { type: 'md-create', size: 'small' } })])
        }
      })
    }
  },
  watch: {
    url (value) {
      this.$nextTick(() => this.refresh())
    },
    'initOptions.q' (value) {
      this.$nextTick(() => this.refresh(this.initOptions))
    }
  }
}
</script>

<style lang="less">
  .paginated-table {
    .ivu-page {
      float: right;
      margin-top: 15px;
    }
  }
</style>
